import { SPREADSHEET_CELL_DATA_UPDATE } from './spreadsheetCellData.actionTypes';
import { type SpreadsheetCellData } from './spreadsheetCellData.state';

export const updateSpreadsheetCellData = (newSpreadsheetCellData: SpreadsheetCellData) => ({
  type: SPREADSHEET_CELL_DATA_UPDATE,
  payload: {
    newSpreadsheetCellData,
  },
}) as const;
